@if (errors && errors[key] && isArray(errors[key])) {
  @for (error of errors[key]; track error) {
    <small class="text-danger">{{error}}</small>
  }
}
@if (errors && errors[key] && !isArray(errors[key])) {
  <small class="text-danger">{{errors[key]}}</small>
}